import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RoutingAx from 'app/actions/routing';

class Link extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    const {skipConfirm, target, secondaryOnClick, navTo, href, replace} = this.props;
    // go with default behavior (open in new tab) if metaKey is pressed
    if (e.metaKey) return;
    // respect _blank
    if (target === '_blank') return;
    //
    secondaryOnClick && secondaryOnClick(e);
    e.preventDefault();
    navTo(href, skipConfirm, replace);
  }

  render() {
    const { children, onClick, secondaryOnClick, navTo, skipConfirm, replace, ...props } = this.props;

    return (
      <a {...props} onClick={onClick || this.onClick}>{children}</a>
    );
  }

}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  // if you want the default onClick functionality, but also want to trigger something else
  secondaryOnClick: PropTypes.func,
  skipConfirm: PropTypes.bool,
  replace: PropTypes.bool,
};

Link.defaultProps = {
  href: '#',
  target: '_self',
  className: '',
  children: null,
  skipConfirm: false,
  replace: false,
};

const dispatchToProps = (dispatch) => ({
  navTo: (path, skipConfirm, replace) => dispatch(RoutingAx.navTo(path, {skipConfirm, replace})),
})

export default connect(undefined, dispatchToProps)(Link);
